<div class="banner">
  <mat-icon>check_circle_outline</mat-icon>
  <div class="title">{{ 'ACTIVATION.CONFIRMATION_PAGE.ACTIVATION_MESSAGE_DIALOG.TITLE' | translate }}</div>
</div>
<mat-dialog-content class="top-padding">
  <div>
    <div class="complete-setup">
      {{ 'ACTIVATION.CONFIRMATION_PAGE.ACTIVATION_MESSAGE_DIALOG.COMPLETE_SETUP' | translate }}
    </div>
    <div class="minor-header">
      {{ 'ACTIVATION.CONFIRMATION_PAGE.ACTIVATION_MESSAGE_DIALOG.PRODUCTS_HAVE_IMPORTANT_INFO' | translate }}
    </div>
  </div>
  <ng-container *ngFor="let app of data.apps" [ngSwitch]="app.type">
    <div class="icon-and-name">
      <va-icon class="icon" [diameter]="32" [iconUrl]="app.icon" [iconName]="app.name"></va-icon>
      <div>{{ app.name }}</div>
    </div>
    <!-- Google Workspace -->
    <div *ngSwitchCase="activationMessageSupportedApps.WORKSPACE">
      <div class="message-padding"></div>
      <div *ngIf="!hasGoogleTransferApp">
        <span
          [innerHtml]="'ACTIVATION.CONFIRMATION_PAGE.ACTIVATION_MESSAGE_DIALOG.CLICK_THE_PRODUCT_ICON_THEN' | translate"
        ></span>
        <ul>
          <li>{{ 'ACTIVATION.CONFIRMATION_PAGE.ACTIVATION_MESSAGE_DIALOG.DOMAIN_VERIFICATION' | translate }}</li>
          <li>
            {{ 'ACTIVATION.CONFIRMATION_PAGE.ACTIVATION_MESSAGE_DIALOG.ACCESS_TO_MAP_GOOGLE_USER' | translate: {appName:
            'COMMON.BUSINESS_APP' | translate} }}
          </li>
        </ul>
        <div class="need-help">
          <i>{{ 'ACTIVATION.CONFIRMATION_PAGE.ACTIVATION_MESSAGE_DIALOG.NEED_HELP_GOOGLE' | translate }}</i>
          {{ 'ACTIVATION.CONFIRMATION_PAGE.ACTIVATION_MESSAGE_DIALOG.CONTACT_SUPPORT_AT' | translate }}
          <a href="tel:1-844-955-6650">1-844-955-6650</a>
        </div>
      </div>
      <div
        class="tranfer-message"
        *ngIf="hasGoogleTransferApp"
        [innerHtml]="'ACTIVATION.CONFIRMATION_PAGE.ACTIVATION_MESSAGE_DIALOG.CLICK_THE_GOOGLE_ICON' | translate"
      ></div>
    </div>
    <!-- Office -->
    <div *ngSwitchCase="activationMessageSupportedApps.OFFICE">
      <div class="message-padding"></div>
      <p
        [innerHtml]="'ACTIVATION.CONFIRMATION_PAGE.ACTIVATION_MESSAGE_DIALOG.MICROSOFT_CLOUD_AGREEMENT' | translate"
      ></p>
      <span
        [innerHtml]="'ACTIVATION.CONFIRMATION_PAGE.ACTIVATION_MESSAGE_DIALOG.CLICK_THE_PRODUCT_ICON' | translate"
      ></span>
      <ul>
        <li>{{ 'ACTIVATION.CONFIRMATION_PAGE.ACTIVATION_MESSAGE_DIALOG.DOMAIN_VERIFICATION' | translate }}</li>
        <li>
          {{ 'ACTIVATION.CONFIRMATION_PAGE.ACTIVATION_MESSAGE_DIALOG.ACCESS_TO_MAP_OFFICE_365_LICENSE' | translate }}
        </li>
      </ul>
      <div class="need-help">
        <i>{{ 'ACTIVATION.CONFIRMATION_PAGE.ACTIVATION_MESSAGE_DIALOG.NEED_HELP_OFFICE_365' | translate }}</i>
        {{ 'ACTIVATION.CONFIRMATION_PAGE.ACTIVATION_MESSAGE_DIALOG.CONTACT_SUPPORT_AT' | translate }}
        <a href="tel:1-844-955-6650">1-844-955-6650</a>
      </div>
    </div>
  </ng-container>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-raised-button color="primary" matDialogClose="">
    {{ 'ACTIVATION.CONFIRMATION_PAGE.ACTIVATION_MESSAGE_DIALOG.AGREE_AND_CONTINUE' | translate }}
  </button>
</mat-dialog-actions>
